// Core modules
import { Component, OnInit, Input, OnChanges, ViewChild, Output, EventEmitter, AfterViewInit, AfterViewChecked } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

// Application services
import { ClientService } from 'app/services/client.service';
import { ImmediateSettingsComponent } from '../immediate-settings/immediate-settings.component';

/**
 * Email alert settings component
 */
@Component({
    selector: 'app-email-settings',
    templateUrl: './email-settings.component.html',
    styleUrls: ['./email-settings.component.scss'],
    standalone: false
})
export class EmailSettingsComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() settings;
  @ViewChild(ImmediateSettingsComponent, { static: false }) immediateSettingsComponent: ImmediateSettingsComponent;
  @Output() immediateSettingsReady = new EventEmitter<ImmediateSettingsComponent>();


  public surveyEscalationSettings: any;
  public form: UntypedFormGroup;
  public emailForm: UntypedFormGroup;
  public keywordForm: UntypedFormGroup;
  public _componentReady = false;


  /**
   * Life cycle method
   * @param clientService Client service
   * @param fb FormBuilder
   */
  constructor(
    private clientService: ClientService,
    private fb: UntypedFormBuilder
  ) {
  }

  /**
   * Returns schedule
   */
  get schedule(): AbstractControl {
    return this.form.get('schedule');
  }

  get email(): AbstractControl {
    return this.emailForm.get('email');
  }

  /**
   * Find default survey escalation settings and initialize form
   */
  ngOnInit(): void {
    this.surveyEscalationSettings = this.clientService.getDefaultSurveyEscalation();
    this.initializeForm();
  }



  ngAfterViewChecked(): void {
    if (this.immediateSettingsComponent && !this._componentReady) {
      this._componentReady = true;
      this.immediateSettingsReady.emit(this.immediateSettingsComponent);
      console.log('ImmediateSettingsComponent available:', this.immediateSettingsComponent);
    }
  }

  /**
   * Settings the value received from parent to child
   */
  ngOnChanges(): void {
    if (this.form && this.settings) {
      this.surveyEscalationSettings = this.settings.surveyEscalation;
      if (this.surveyEscalationSettings) {
        this.form.patchValue(this.surveyEscalationSettings);
      }
      this.emailForm.patchValue(this.settings.surveyEscalation);
      this.emailForm.patchValue(this.settings);
    }
  }

  /**
   * Initialize form for email settings
   */
  initializeForm(): void {
    this.form = this.fb.group({
      longCommentsMinChars: new UntypedFormControl(),
      schedule: new UntypedFormControl(),
      hours: new UntypedFormControl(),
      minScore: new UntypedFormControl(),
      npsAlert: new UntypedFormControl(),
    });

    this.emailForm = this.fb.group({
      needsSurveyResponseEscalation: new UntypedFormControl(),
      emailAlertsLimitedTo: new UntypedFormControl(),
      email: new UntypedFormControl('', [Validators.email]),
      username: new UntypedFormControl()
    });

    this.keywordForm = this.fb.group({
      keyword: new UntypedFormControl()
    });
  }

  removeRecipient(idx: number) {
    this.surveyEscalationSettings.reportToEmail.splice(idx, 1);
  }

  removeKeyword(idx: number) {
    this.surveyEscalationSettings.customLookoutKeyWords.splice(idx, 1);
  }

  /**
   * Add user in reportToEmail Array
   */
  addUser(): void {
    if (this.emailForm.value.email && this.emailForm.value.username) {
      this.surveyEscalationSettings.reportToEmail.push(this.emailForm.value);
      this.emailForm.reset();
    }
  }

  /**
   * Add keyword in customLookoutKeywords Array
   */
  addKeyword(): void {
    if (this.keywordForm.value.keyword) {
      this.surveyEscalationSettings.customLookoutKeyWords.push(this.keywordForm.value.keyword);
      this.keywordForm.reset();
    }
  }

  detractorAlertEnabled(): boolean {
    return this.form.value.npsAlert?.includes('detractor');
  }
}
